<template>
  <form @submit.prevent="validarForm">
    <h6 class="text-primary linea2">Familiares o terceros expuestos políticamente</h6>
    <div class="alert alert-secondary fade show" :class="!valLista && 'alert-danger'" role="alert"
         v-if="validacion>0">
      Debes completar mínimo&nbsp;<b>{{ validacion }}</b>&nbsp;Registro<span
        v-if="validacion>1">s</span>
    </div>
    <div class="pb-2">
      <form class="row" @submit.prevent="validar">
        <div class="form-group col-md-6 col-12">
          <label><i class="fa fa-asterisk text-danger"></i>Tipo de identificación</label>
          <combo-box
              v-model="datos.tipoDni"
              :valid="errors.has('tipo de identificación')"
              :opciones="lstTipoDni"
              name="tipo de identificación"
              v-validate="{required:true,obj:true}"
          />
          <span class="form-text text-danger">{{ errors.first("tipo de identificación") }}</span>
        </div>
        <div class="form-group col-md-6 col-12">
          <label for="númerodi"><i class="fa fa-asterisk text-danger"></i>Número de identificación</label>
          <input
              type="tel"
              class="form-control"
              :class="errors.has('número de identificación') && 'is-invalid'"
              v-model="datos.numero"
              name="número de identificación"
              id="númerodi"
              v-validate="{required:true,ci:datos.tipoDni}"
          >
          <span class="form-text text-danger">{{ errors.first("número de identificación") }}</span>
        </div>
        <div class="form-group col-md-4 col-6">
          <label for="apellidos"><i class="fa fa-asterisk text-danger"></i>Apellidos</label>
          <input
              type="text"
              class="form-control"
              :class="errors.has('apellidos') && 'is-invalid'"
              v-model="datos.apellidos"
              name="apellidos"
              id="apellidos"
              v-validate="{required:true,max:50}"
          >
          <span class="form-text text-danger">{{ errors.first("apellidos") }}</span>
        </div>
        <div class="form-group col-md-4 col-6">
          <label for="nombres"><i class="fa fa-asterisk text-danger"></i>Nombres</label>
          <input
              type="text"
              class="form-control"
              :class="errors.has('nombres') && 'is-invalid'"
              v-model="datos.nombres"
              name="nombres"
              id="nombres"
              v-validate="{required:true,max:50}"
          >
          <span class="form-text text-danger">{{ errors.first("nombres") }}</span>
        </div>
        <div class="form-group col-md-4 col-12">
          <label for="entidad"><i class="fa fa-asterisk text-danger"></i>Entidad en la que labora</label>
          <input
              type="text"
              class="form-control"
              :class="errors.has('entidad') && 'is-invalid'"
              v-model="datos.entidad"
              name="entidad"
              id="entidad"
              v-validate="{required:true,max:50}"
          >
          <span class="form-text text-danger">{{ errors.first("entidad") }}</span>
        </div>
        <div class="form-group col-md-6 col-12">
          <label for="cargo"><i class="fa fa-asterisk text-danger"></i>Cargo</label>
          <input
              type="text"
              class="form-control"
              :class="errors.has('cargo') && 'is-invalid'"
              v-model="datos.cargo"
              name="cargo"
              id="cargo"
              v-validate="{required:true,max:50}"
          >
          <span class="form-text text-danger">{{ errors.first("cargo") }}</span>
        </div>
        <div class="form-group col-md-6 col-12">
          <label><i class="fa fa-asterisk text-danger"></i>Parentesco</label>
          <combo-box
              v-model="datos.parentesco"
              :opciones="lstParentesco"
              name="parentesco"
              :valid="errors.has('parentesco')"
              v-validate="{required:true,obj:true}"
          ></combo-box>
          <span class="form-text text-danger">{{ errors.first("parentesco") }}</span>
        </div>
        <div class="col-12 col-md-12 p-1">
          <div class="col-12 col-md-4 p-1">
            <button type="submit" class="btn btn-success btn-elevate btn-pill btn-block">Agregar</button>
          </div>
        </div>
      </form>
      <div class="table-responsive pt-2">
        <table class="table table-sm table-striped">
          <thead>
          <tr>
            <th>Nombres y apellidos</th>
            <th>Tipo de relación</th>
            <th>Número de identificación</th>
            <th>Cargo</th>
            <th>Entidad</th>
            <th class="text-center">Acción</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(i,ii) in registros" :key="ii" class="animated fadeInDown">
            <td>{{ i.dt1 || '' }} {{ i.dt2 || '' }}</td>
            <td>{{ lstParentesco.length ? lstParentesco.find(j => j.id === i.ndt2).dt1 : '' }}</td>
            <td>{{ i.dt3 }}</td>
            <td>{{ i.dt4 }}</td>
            <td>{{ i.dt5 }}</td>
            <td class="text-center">
              <button type="button" class="btn btn-link btn-sm" v-on:click="eliminar(ii)" title="Eliminar">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
          <tr v-if="!registros.length">
            <td colspan="6" class="text-center text-muted">
              No hay elementos agregados<br>
              <span class="text-danger">Agregue elementos con el botón <code>Agregar</code></span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-12 col-md-12 p-1">
        <button type="submit" class="btn btn-primary btn-elevate btn-pill btn-block"
                :class="cargando ? 'kt-spinner kt-spinner--left kt-spinner--sm kt-spinner--light' : ''"
                :disabled="cargando">Guardar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import constantes from "@/constantes";
import comboBox from "../comboBox";
import {catalogos, persona} from "@/servicios";

export default {
  name: "familiar-expuesto",
  data: () => ({
    registros: [],
    lstParentesco: [],
    cargando: false,
    datos: {
      nombres: null,
      apellidos: null,
      numero: null,
      cargo: null,
      entidad: null,
      parentesco: null,
      tipoDni: null,
    }
  }),
  components: {
    comboBox
  },
  props: {
    validacion: {
      type: Number,
      default: 1
    },
    sync: {
      type: Boolean,
      default: false,
    },
    previos: {
      type: Array
    },
    formulario: {
      type: Object,
      required: true
    },
    tipo: {
      type: Object,
      required: true
    },
    lstTipoDni: {
      type: Array,
      required: true
    },
  },
  computed: {
    valLista: function () {
      return this.registros.length >= this.validacion;
    }
  },
  filters: {
    fechaLarga: function (valor) {
      if (valor) {
        return constantes.funciones.formatoFechaD(valor)
      } else {
        return null;
      }
    }
  },
  methods: {
    validarForm: function () {
      if (this.registros.length >= this.validacion) {
        this.cargando = true;
        this.enviarDatos();
      } else {
        this.$toast.show(`Completa el formulario ` + this.formulario.id + " " + this.tipo.titulo);
        setTimeout(() => {
          let container = this.$el.querySelector('.alert-danger');
          container.scrollIntoView();
        }, 100);
      }
    },
    validar: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const datos = {
            dt1: this.datos.nombres,
            dt2: this.datos.apellidos,
            dt3: this.datos.numero,
            dt4: this.datos.cargo,
            dt5: this.datos.entidad,
            ndt2: this.datos.parentesco.id,
            ndt3: this.datos.tipoDni.id,
          };
          this.datos = {
            nombres: null,
            apellidos: null,
            numero: null,
            cargo: null,
            entidad: null,
            parentesco: null,
            tipoDni: null,
          };
          this.registros.splice(0, 0, datos);
        } else {
          this.$toast.show(`Completa el formulario Familiares o terceros expuestos políticamente`);
        }
      });
    },
    enviarDatos: function () {
      persona.actualizacionFamiliaExpuesta(this.registros).then(() => {
        this.cargando = false;
        this.$emit('input', {complete: true, registros: this.registros});
      }).catch(() => {
        this.cargando = false;
      });
    },
    eliminar: function (index) {
      this.registros.splice(index, 1);
    },
    consultarCatalogos: function () {
      catalogos.tipoParentesco().then(r => r.data).then(response => {
        this.lstParentesco = response;
      });
    }
  },
  mounted() {
    this.consultarCatalogos();
  },
  watch: {
    sync: function () {
      this.previos.forEach(
          (e) => {
            this.registros.push(e)
          }
      )
    }
  }
}
</script>

<style scoped>

</style>
